import { useEffect, useState } from 'react';
import { LegendItem, StatisticLineChartData } from '../types/statistics.types';
import LineChart from './line-chart';
import LineChartLegend from './line-chart.legend';
import Skeleton from 'react-loading-skeleton';
import './statistics-section.line-chart.scss';


interface StatisticsSectionLineChartProps {
    data: StatisticLineChartData[];
    isLoading?: boolean
}

const StatisticsSectionLineChart: React.FC<StatisticsSectionLineChartProps> = ({ data, isLoading = false }) => {

    const [legendItems, setLegendItems] = useState<LegendItem[]>(data.map((item) =>
    ({
        label: item.label,
        selected: true,
        colors: item.colors
    })));

    useEffect(() => {
        setLegendItems(data.map((item) =>
    ({
        label: item.label,
        selected: true,
        colors: item.colors
    })))
    }, [data])    

    const visibleData = data.filter((dataset) =>
        legendItems.find((legend) => legend.label === dataset.label && legend.selected)
    );

    return (
        <div className='statistics-section-line-chart flex-column flex-gap-10'>
            {
                isLoading ? <div className='skeleton-container'> <Skeleton width="100%" height={30} highlightColor="#218579"/></div> : <>
                    <LineChartLegend items={legendItems} setItems={setLegendItems} />
                    <LineChart datasets={visibleData} />
                </>
            }

        </div>
    )
}

export default StatisticsSectionLineChart;